<template>
  <div>
    <br />
    <nav id="nav">
      <router-link to="/">Home</router-link>
      <router-link to="/blog">Blog</router-link>
      <router-link to="/music" style="color: purple">Music</router-link>
    </nav>
    <br />
    <router-view />
    <footer style="padding: 10px">
      <hr />
      <div style="display: flex">
        <div style="width: 100%">
          <router-link class="footer-link" @click="moveUp" to="/"
            >Home</router-link
          ><br />
          <router-link class="footer-link" @click="moveUp" to="/blog"
            >Blog</router-link
          ><br />
          <router-link class="footer-link" @click="moveUp" to="/music"
            >Music</router-link
          ><br />
        </div>
        <div style="width: 100%">
          <a
            class="footer-link"
            href="https://github.com/Dineth-De-Silva"
            rel="noopener noreferrer"
          >
            Github</a
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<style>
@font-face {
  font-family: "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("./assets/fonts/Noto_Sans/NotoSans-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Outfit";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("./assets/fonts/Outfit/Outfit-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Outfit";
  font-style: normal;
  font-weight: bold;
  font-display: swap;
  src: url("./assets/fonts/Outfit/Outfit-Bold.ttf") format("truetype");
}
#app {
  max-width: 700px;
  margin: auto;
  padding: 20px;
  font-family: Outfit;
}
#nav {
  font-size: large;
  display: flex;
  padding: 10px;
  justify-content: center;
}
#nav a {
  color: black;
  padding: 8px;
  margin: 8px;
  border-radius: 10px;
  text-decoration: none;
}
#nav a:hover {
  background-color: whitesmoke;
}
#nav a.active {
  color: black;
  font-weight: bold;
}
.footer-link {
  text-decoration: none;
  color: #444444;
  font-size: large;
}
.footer-link:hover {
  color: black;
}
@media only screen and (max-width: 700px) {
  #nav {
    justify-content: left;
  }
}
</style>

<script>
export default {
  name: "App",
  methods: {
    moveUp() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
